import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=25508b20&scoped=true&"
import script from "./Views.vue?vue&type=script&lang=js&"
export * from "./Views.vue?vue&type=script&lang=js&"
import style0 from "./Views.vue?vue&type=style&index=0&id=25508b20&lang=scss&scoped=true&"
import style1 from "./Views.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25508b20",
  null
  
)

export default component.exports